import { Grid } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import CardEvent from '../../CardEvent/CardEvent';
import CardButtons from '../../CardButtons';
import { GROUP_USER } from '../../../../../../config/appGroupConfig';
import { APP_ROUTES } from '../../../../../../constants/app-routes';

function CardByRole({ role, event, handleRateClicked }) {
  const navigate = useNavigate();
  const getFullName = (user) => `${user?.name} ${user?.last_name}`;

  const handleViewClick = (vendor) => {
    if (vendor?.id) {
      navigate(APP_ROUTES.VENDOR_PUBLIC_PROFILE.replace(':vendorId', vendor.id));
    }
  };

  const handleButtonClick = (buttonType, vendor) => {
    if (buttonType === 'primary') {
      // View button
      handleViewClick(vendor);
    } else if (buttonType === 'secondary') {
      // Rate button
      handleRateClicked(vendor);
    }
  };

  if (role === GROUP_USER.VENDOR) {
    return (
      <Grid key={uuidv4()} item sm={5} lg={3} marginBottom={8} paddingLeft={8}>
        <CardEvent
          eventId={event.id}
          title={event.name}
          image={event.photo}
          description={`Contact: ${event.contact_name}`}
          status={event.status}
          cardFooter={
            <CardButtons
              primaryButton="View"
              secondaryButton="Rate"
              eventId={event.id}
              onHandleClick={(e, buttonType) => {
                if (buttonType === 'primary') {
                  // View button - navigate to venue profile if needed
                  // For vendor role viewing venues, this might need different handling
                } else if (buttonType === 'secondary') {
                  handleRateClicked(event.venue?.user_owner);
                }
              }}
            />
          }
        />
      </Grid>
    );
  }

  if (role === GROUP_USER.VENUE) {
    return (
      event.vendorEvents?.length > 0 &&
      event.vendorEvents.map((ve) => (
        <Grid key={uuidv4()} item sm={5} lg={3} marginBottom={8} paddingLeft={8}>
          <CardEvent
            eventId={ve.id}
            title={getFullName(ve.vendor)}
            image={ve.vendor?.image}
            description={event.name}
            status={event.status}
            cardFooter={
              <CardButtons
                primaryButton="View"
                secondaryButton="Rate"
                eventId={ve.id}
                onHandleClick={(e, buttonType) => handleButtonClick(buttonType, ve.vendor)}
              />
            }
          />
        </Grid>
      ))
    );
  }
}

CardByRole.propTypes = {
  role: PropTypes.string.isRequired,
  event: PropTypes.instanceOf(Object).isRequired,
  handleRateClicked: PropTypes.func.isRequired,
};

export default CardByRole;
